var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "nav-bar" }, [
    _c(
      "li",
      { staticClass: "home", class: { "qyg-liWidth": _vm.isInQYGChannel } },
      [
        _vm.isInQYGChannel
          ? _c(
              "router-link",
              {
                class: { active: _vm.activeTab === _vm.qygHomeHref },
                attrs: { to: _vm.qygHomeHref },
              },
              [
                _c(
                  "icon",
                  {
                    attrs: {
                      size: "28",
                      color:
                        _vm.activeTab === _vm.qygHomeHref
                          ? _vm.activeColor
                          : "",
                    },
                  },
                  [_vm._v("tab_shouye")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v("首页")]),
              ],
              1
            )
          : _c(
              "router-link",
              { class: { active: _vm.activeTab === "/" }, attrs: { to: "/" } },
              [
                _c(
                  "icon",
                  {
                    attrs: {
                      size: "28",
                      color: _vm.activeTab === "/" ? _vm.activeColor : "",
                    },
                  },
                  [_vm._v("tab_shouye")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v("首页")]),
              ],
              1
            ),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.isInQYGChannel
      ? _c(
          "li",
          {
            staticClass: "enterprise",
            class: { "qyg-liWidth": _vm.isInQYGChannel },
          },
          [
            _c(
              "router-link",
              {
                class: { active: _vm.activeTab === "/enterprise" },
                attrs: { to: "/enterprise" },
              },
              [
                _c(
                  "icon",
                  {
                    attrs: {
                      size: "28",
                      color:
                        _vm.activeTab === "/enterprise" ? _vm.activeColor : "",
                    },
                  },
                  [_vm._v("icon_fuli")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v("企业福利")]),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "li",
      {
        staticClass: "shop-cart",
        class: { "qyg-liWidth": _vm.isInQYGChannel },
      },
      [
        _c(
          "router-link",
          {
            class: { active: _vm.activeTab === "/cart" },
            attrs: { to: "/cart" },
          },
          [
            _c(
              "icon",
              {
                class: { "cart-center": _vm.isInQYGChannel },
                attrs: {
                  size: "31",
                  color: _vm.activeTab === "/cart" ? _vm.activeColor : "",
                },
              },
              [_vm._v("tab_gouwuche")]
            ),
            _vm._v(" "),
            _c(
              "mt-badge",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !!_vm.cartNum,
                    expression: "!!cartNum",
                  },
                ],
                staticClass: "badge",
                attrs: { size: "small", color: "#c03131" },
              },
              [_vm._v(_vm._s(_vm.cartNum))]
            ),
            _vm._v(" "),
            _c("span", [_vm._v("购物车")]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      { staticClass: "center", class: { "qyg-liWidth": _vm.isInQYGChannel } },
      [
        _c(
          "router-link",
          {
            class: { active: _vm.activeTab === "/center" },
            attrs: { to: "/center" },
          },
          [
            _c(
              "icon",
              {
                attrs: {
                  size: "28",
                  color: _vm.activeTab === "/center" ? _vm.activeColor : "",
                },
              },
              [_vm._v("tab_wode")]
            ),
            _vm._v(" "),
            _c("span", [_vm._v("我的")]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }